import { IKalturaConfig, IPlayerConfig } from '../Models/PlayerModels'
import { playerConfig } from './constants'
import { translations } from '../Kaltura/translations'
import { getParameterByName } from '../../../utils'

export const bitrateConfig = (bitrate: string) => {
  return {
    enabled: true,
    fpsDroppedFramesInterval: 5000,
    fpsDroppedMonitoringThreshold: 0.2,
    capLevelOnFPSDrop: false,
    capLevelToPlayerSize: false,
    restrictions: {
      minBitrate: 0,
      maxBitrate: parseInt(bitrate + '000') || 720000,
      maxHeight: parseInt(bitrate) || 720,
    },
  }
}

export const kalturaConfig = ({
  targetId,
  autoPlay,
  enable_full_screen,
  shareConfig,
  livePageConfig,
  bitrate,
}: IKalturaConfig) => {
  const config: IPlayerConfig = {
    targetId: targetId,
    provider: {
      partnerId: playerConfig.fakeWindow.siteConfig.kaltura.partnerId,
      uiConfId: playerConfig.fakeWindow.siteConfig.kaltura.uiConfId,
    },
    playback: {
      autoplay: autoPlay ? 'inview' : autoPlay,
      allowMutedAutoPlay: getParameterByName('mute') === 'true',
      inBrowserFullscreen: enable_full_screen,
      screenLockOrientionMode: playerConfig.inWebView && 'landscape',
    },
    plugins: {
      contextMenu: {
        disable: true,
      },
      share: {
        ...shareConfig,
        uiComponent: {
          label: 'shareBottom',
          area: 'BottomBarRightControls',
          replaceComponent: 'Volume',
        },
      },
    },
    cast: {
      receiverApplicationId: 'CF3B07A1',
    },
    advertising: {},
    sources: {},
    ui: {
      components: {},
      locale: 'he',
      translations: {
        he: { ...translations.he },
      },
    },
    player: {
      ...livePageConfig,
    },
    abr: bitrateConfig(bitrate),
    // network: {
    //   requestFilter: networkRequestFilter,
    // },
    disableUserCache: true,
  }
  return config
}
